/**
 * DisplayItem > Profile object.
 *
 * @typedef {Object} Profile
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} userid The users id (as a string, to avoid overflow of max integer numeric value).
 * @property {String} username The users username.
 * @property {String} handle The users handle.
 * @property {String} avatar Direct url of the users avatar image.
 * @property {String} avatarRef String defining the asset ref for the users avatar.
 */
class Profile {

	constructor(userid, username, handle, avatar, avatarRef) {

		this.userid		= userid;
		this.username	= username;
		this.handle		= handle;
		this.avatar		= avatar;
		this.avatarRef	= avatarRef;
	}
}

export default Profile;